import './custom.css'

import { Component, ReactNode } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { FetchData } from './components/FetchData';
import { Firmware } from './components/Firmware';
import Register from './components/Register';
import Login from './components/Login';
import Settings from './components/Settings';
import Airmap from './components/Airmap';
import ConfirmEmail from './components/ConfirmEmail';
import Mp from './downloads/Mp';
import Qgc from './downloads/Qgc';
import Alp from './downloads/Alp';
import ForgotPassword from './components/ForgotPassword';
import ForgotPasswordConfirmation from './components/ForgotPasswordConfirmation';
import OnlineDrones from './components/OnlineDrones';
import Users from './components/Users';
import Wiki from './components/wiki/Wiki';
import QuickStart from './components/wiki/QuickStart';
import Ogn from './components/wiki/Ogn';
import Yellcs from './components/trash/Yellcs';
import Statistic from './components/statistics/Statistic';
import ModemStatistic from './components/statistics/ModemStatistic';
import ModemsStatistic from './components/statistics/ModemsStatistic';
import FirmwareV2 from './components/FirmwareV2';
import Console from "./components/console/Console"
import AdminSubscription from './components/AdminSubscriptions';
import UserSubscription from './components/console/userSubscription/UserSubscription';
import { RequireAuth, RedirectIfAuthenticated } from './AuthContext';

export default class App extends Component {
    static displayName = App.name;

    override render(): ReactNode {
        return (
            <>
                <Layout>
                    <Route path='/' element={<RequireAuth><Console /></RequireAuth>} />
                    <Route path='/fetch-data' element={<FetchData />} />
                    <Route path='/firmware' element={<RequireAuth><FirmwareV2 /></RequireAuth>} />
                    <Route path='/firmware_old' element={<RequireAuth><Firmware /></RequireAuth>} />
                    <Route path='/settings' element={<RequireAuth><Settings /></RequireAuth>} />
                    <Route path='/login' element={<RedirectIfAuthenticated><Login /></RedirectIfAuthenticated>} />
                    <Route path='/registration' element={<Register />} />
                    <Route path='/forgot-pass' element={<ForgotPassword />} />
                    <Route path='/forgot-pass-confirm' element={<ForgotPasswordConfirmation />} />
                    {/*<Route path='/drones' element={<Drones />}/>*/}
                    <Route path='/map' element={<Airmap />} />
                    <Route path='/confirm-email' element={<ConfirmEmail />} />
                    <Route path='/mp' element={<Mp />} />
                    <Route path='/qgc' element={<Qgc />} />
                    <Route path='/alp' element={<Alp />} />
                    <Route path='/onlineDrones' element={<RequireAuth><OnlineDrones /></RequireAuth>} />
                    <Route path='/users' element={<RequireAuth><Users /></RequireAuth>} />
                    <Route path='/wiki' element={<Wiki />}>
                        <Route path="quickStart" element={<QuickStart />} />
                        <Route path="ogn" element={<Ogn />} />
                    </Route>
                    <Route path='/yellcs' element={<Yellcs />} />
                    <Route path='/adminSubscriptions' element={<RequireAuth><AdminSubscription /></RequireAuth>} />
                    <Route path='/subscriptions' element={<RequireAuth><UserSubscription /></RequireAuth>} />
                    <Route path='/statistics' element={<RequireAuth><Statistic /></RequireAuth>}>
                        {/*<Route path="modem/:imei" element={<ModemStatistic />} />*/}
                    </Route>
                    <Route path='/statistics/modem' element={<RequireAuth><ModemStatistic /></RequireAuth>}></Route>
                    <Route path='/statistics/modems' element={<RequireAuth><ModemsStatistic /></RequireAuth>}></Route>
                </Layout>
            </>
        );
    }
}
